export enum LanguageEnum {
  NL = "nl_NL",
  EN = "en_GB",
  DE = "de_DE",
}
